import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { Button } from '@mui/material';

import { FlexipassDoor } from '../../../models';

import styles from './DoorList.module.scss';

interface DoorListProps {
  doors: FlexipassDoor[];
  onClick: (door: FlexipassDoor) => void;
}

export const DoorList = ({ doors, onClick }: DoorListProps) => {
  const intl = useIntl();

  const renderDoorList = useCallback(() => {
    if (!doors?.length) {
      return (
        <div className={styles.empty}>
          {intl.formatMessage({
            id: 'digital_keys/no_doors_found',
            defaultMessage: 'No doors found',
          })}
        </div>
      );
    }

    return (
      <>
        {doors.map((door) => (
          <div key={door.id} className={styles.item}>
            <span>{door.display_name ?? door.door_name}</span>
            {door.is_available ? (
              <Button
                variant="contained"
                color="primary"
                style={{
                  borderRadius: '2rem',
                  padding: '0.5rem 2.5rem',
                  lineHeight: 1.5,
                  backgroundColor: '#001238',
                  textTransform: 'none',
                }}
                onClick={() => onClick(door)}
              >
                {intl.formatMessage({
                  id: 'digital_keys/open',
                  defaultMessage: 'Open',
                })}
              </Button>
            ) : (
              <span>
                {intl.formatMessage({
                  id: 'digital_keys/not_available',
                  defaultMessage: 'Not Available',
                })}
              </span>
            )}
          </div>
        ))}
      </>
    );
  }, [doors, intl, onClick]);

  return (
    <div className={styles.list}>
      <header className={styles.header}>
        {intl.formatMessage({
          id: 'digital_keys/digital_keys',
          defaultMessage: 'Digital Keys',
        })}
      </header>
      {renderDoorList()}
    </div>
  );
};
